module.exports = __webpack_public_path__ + "assets/images/create_devis.0b2906ab53f22f46c646ab5835b1bca5.png";